import { CustomHeader as CustomHeaderShared } from "@shared/src";

interface CustomHeaderProps {
  className?: string;
  title?: string | React.ReactNode;
  titleColor?: string;
  titleStyle?: React.CSSProperties;
  iconColor?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
  goHome?: () => void;
  goBack?: () => void;
  close?: () => void;
  actionItems?: {
    name: string;
    isIcon?: boolean;
    badge?: string | number | boolean;
    badgeType?: "text" | "icon" | "dot";
    callback?: () => void;
  }[];
  scrollHide?: boolean;
  headerPostion?: "fixed" | "absolute" | "relative";
  linkItem?: { name: string; callback: () => void; color?: string };
  children?: React.ReactNode;
  id?: string;
}

/**
 * AppHeader와 동일한 스타일 컴포넌트 / 뒤로가기, 닫기 함수를 받아서 사용할 수 있도록 추가
 * AppHeader 구조/클래스 등 변경 시 동일하게 변경 필요 (Appheader와 다를 경우 맞춰주시면 됩니다!)
 * titleColor, iconColor, backgroundColor, style 등 커스텀 가능 (단, 색깔별 icon 이미지 같은 경우엔 추가 업로드가 필요할 수 있음 className=icon-close-${iconColor} 이런식으로 처리됨)
 *
 * @param className 커스텀 클래스
 * @param title 헤더 타이틀
 * @param titleColor 헤더 타이틀 색상
 * @param iconColor 아이콘 색상
 * @param backgroundColor 헤더 배경색
 * @param style 커스텀 스타일
 * @param goBack 뒤로가기 함수
 * @param close 닫기 함수
 * @param actionItems 헤더 우측 액션 아이템
 * @param scrollHide 스크롤 시 헤더 숨김 여부
 * @param headerPostion 헤더 포지션
 */
const CustomHeader = ({
  className = "",
  title,
  titleColor = "#000",
  titleStyle = {},
  iconColor = "black",
  backgroundColor = "#fff",
  style = {},
  goBack,
  goHome,
  close,
  actionItems,
  scrollHide = true,
  headerPostion = "fixed",
  linkItem,
  children,
  id = "AppHeaderWrap",
}: CustomHeaderProps) => {
  return (
    <CustomHeaderShared
      {...{
        className,
        title,
        titleColor,
        titleStyle,
        iconColor,
        backgroundColor,
        style,
        goBack,
        goHome,
        close,
        actionItems,
        scrollHide,
        headerPostion,
        linkItem,
        children,
        id,
      }}
    />
  );
};

export default CustomHeader;
